/**
 * ============================================================================
 * DOGSTER BARF · Guardián de cantidad mínima en el carrito
 * ----------------------------------------------------------------------------
 * Funciona en CUALQUIER carrito de Shopify (cajón lateral, página /cart,
 * notificación emergente) sin depender de la estructura HTML del tema:
 * escucha cambios en cualquier <input type="number"> de cantidad, y usa
 * /cart.js para identificar si esa línea es un producto "protegido" (los
 * que la calculadora BARF agregó) revisando la propiedad oculta
 * "_dogster_min_qty" que el carrito ya trae en cada línea — no hay que
 * mantener ninguna lista de productos aquí.
 *
 * Si el cliente intenta bajar la cantidad por debajo del mínimo, este
 * script la corrige de vuelta al mínimo, muestra un aviso en español, y
 * refresca la página para que el cambio se vea reflejado en todos lados
 * (cajón, ícono del carrito, totales).
 *
 * INSTALACIÓN: este archivo se debe cargar en TODAS las páginas (el
 * carrito puede editarse desde cualquier lado), así que va en
 * layout/theme.liquid, justo antes de </body>:
 *
 *   {{ 'barf-cart-min-qty-guard.js' | asset_url | script_tag }}
 *
 * No requiere ningún otro archivo ni configuración.
 * ============================================================================
 */
(function () {
  'use strict';

  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let correcting = false; // evita corregir dos veces a la vez

  function fetchCart() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
  }

  function showNotice(inputEl, message) {
    const existing = inputEl.parentElement.querySelector('.barf-min-qty-notice');
    if (existing) existing.remove();
    const el = document.createElement('div');
    el.className = 'barf-min-qty-notice';
    el.setAttribute('role', 'alert');
    el.textContent = message;
    el.style.cssText = 'color:#B23A2E;font-size:0.82rem;margin-top:6px;';
    inputEl.insertAdjacentElement('afterend', el);
  }

  function correctLine(lineKey, minQty, inputEl) {
    if (correcting) return;
    correcting = true;
    fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: minQty })
    })
      .then(() => {
        showNotice(inputEl, `La cantidad mínima de compra para este producto es de 1 kilo (${minQty} bolsas de 250 g). Ajustamos tu pedido.`);
        setTimeout(() => window.location.reload(), 1400);
      })
      .catch(() => { correcting = false; });
  }

  function findGuardedLine(cart, input) {
    // Dawn identifica cada input de cantidad con id="Quantity-N" o
    // "Quantity-N-cart-drawer" o similar, donde N es el índice (1-based)
    // de la línea en /cart.js. Buscamos ese número en el id o en el name.
    const source = (input.id || '') + ' ' + (input.name || '');
    const match = source.match(/Quantity-(\d+)/);
    if (!match) return null;
    const index = parseInt(match[1], 10) - 1;
    const line = cart.items[index];
    if (!line) return null;
    const minQty = parseInt(line.properties && line.properties['_dogster_min_qty'], 10);
    if (!minQty) return null;
    return { line, minQty };
  }

  function handleChange(e) {
    const input = e.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'number') return;
    const newQty = parseInt(input.value, 10);
    if (!newQty || newQty === 0) return; // 0/vacío = quitar del carrito, se permite

    fetchCart().then((cart) => {
      const found = findGuardedLine(cart, input);
      if (!found) return;
      if (newQty < found.minQty) {
        correctLine(found.line.key, found.minQty, input);
      }
    });
  }

  document.addEventListener('change', handleChange, true);
})();
